// extracted by mini-css-extract-plugin
module.exports = {"section":"what-appliances_section__1Cz39"};